import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Grid } from 'semantic-ui-react';

import {
    SprayEquipmentSetId,
    SprayApplicationRate,
    SprayEntityIds
} from 'services/sprayEvents/types';
import { AppState } from 'services/types';
import { Calibration } from 'services/equipmentSets/types';
import { makeSelectCalibrations } from 'services/equipmentSets/selectors';
import SprayEventTypeWeedGate from 'components/SprayEventTypeWeedGate';
import SprayEventTypeCropGate from 'components/SprayEventTypeCropGate';
import SummaryCalibrationsRowWidthListItem from '../SummaryCalibrationsRowWidthListItem';
import SummaryCalibrationsGearListItem from '../SummaryCalibrationsGearListItem';
import SummaryCalibrationsSpeedListItem from '../SummaryCalibrationsSpeedListItem';
import SummaryCalibrationsFlowRateListItem from '../SummaryCalibrationsFlowRateListItem';
import SummaryCalibrationsPressureListItem from '../SummaryCalibrationsPressureListItem';
import SummaryCalibrationsFanSpeedListItem from '../SummaryCalibrationsFanSpeedListItem';
import SummaryCalibrationsEngineRpmListItem from '../SummaryCalibrationsEngineRpmListItem';
import SummaryCalibrationsSwathWidthListItem from '../SummaryCalibrationsSwathWidthListItem';
import SummaryCalibrationsNozzlesPerSideListItem from '../SummaryCalibrationsNozzlesPerSideListItem';

export interface OwnProps {
    equipmentSetId: SprayEquipmentSetId;
    applicationRate: SprayApplicationRate;
    entityIds: SprayEntityIds;
}

export interface ConnectedProps {
    calibrations: Calibration[];
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsListComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { calibrations, equipmentSetId } = this.props;

        return (
            <React.Fragment>
                {calibrations.map(({ id }, index) => (
                    <Grid className="summary-list-item" key={id}>
                        <Grid.Row>
                            <Grid.Column className="summary-list-item-title">
                                Calibration #{index + 1}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column mobile={8} computer={4} tablet={4}>
                                <SummaryCalibrationsRowWidthListItem
                                    equipmentSetId={equipmentSetId}
                                    calibrationId={id}
                                />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={4} tablet={4}>
                                <SummaryCalibrationsGearListItem
                                    equipmentSetId={equipmentSetId}
                                    calibrationId={id}
                                />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={4} tablet={4}>
                                <SummaryCalibrationsSpeedListItem
                                    equipmentSetId={equipmentSetId}
                                    calibrationId={id}
                                />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={4} tablet={4}>
                                <SummaryCalibrationsFlowRateListItem
                                    equipmentSetId={equipmentSetId}
                                    calibrationId={id}
                                />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={4} tablet={4}>
                                <SummaryCalibrationsPressureListItem
                                    equipmentSetId={equipmentSetId}
                                    calibrationId={id}
                                />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={4} tablet={4}>
                                <SummaryCalibrationsEngineRpmListItem
                                    equipmentSetId={equipmentSetId}
                                    calibrationId={id}
                                />
                            </Grid.Column>
                            <SprayEventTypeCropGate>
                                <Grid.Column mobile={8} computer={4} tablet={4}>
                                    <SummaryCalibrationsFanSpeedListItem
                                        equipmentSetId={equipmentSetId}
                                        calibrationId={id}
                                    />
                                </Grid.Column>
                            </SprayEventTypeCropGate>
                            <SprayEventTypeWeedGate>
                                <React.Fragment>
                                    <Grid.Column
                                        mobile={8}
                                        computer={4}
                                        tablet={4}
                                    >
                                        <SummaryCalibrationsSwathWidthListItem
                                            equipmentSetId={equipmentSetId}
                                            calibrationId={id}
                                        />
                                    </Grid.Column>
                                    <Grid.Column
                                        mobile={8}
                                        computer={4}
                                        tablet={4}
                                    >
                                        <SummaryCalibrationsNozzlesPerSideListItem
                                            equipmentSetId={equipmentSetId}
                                            calibrationId={id}
                                        />
                                    </Grid.Column>
                                </React.Fragment>
                            </SprayEventTypeWeedGate>
                        </Grid.Row>
                    </Grid>
                ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    calibrations: makeSelectCalibrations()
});

export default connect(mapStateToProps)(SummaryCalibrationsListComponent);
